import type {CreditCardSkinAppearance} from './types.ts';

export const DEFAULT_SCHEME_LOGO_APPEARANCE: CreditCardSkinAppearance = {
    visaLogoColor: '#FFFFFF',
    amexLogoColor: '#FFFFFF',
    dinersLogoColor: '#FFFFFF',
    jcbLogoColor: '#FFFFFF',
};
